module.exports = __webpack_public_path__ + "50a4f520dd2d9da59ce568fdde1f6e9a.pdf";